import React from 'react'

import { useSaveMinicrud } from './_requests/saveMinicrud'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useMinicrud } from './_load/MinicrudLoader'
import { useModalData } from '../../../components/modals/ModalsContext'

const EditMinicrudForm = () => {
  const minicrud = useMinicrud()
  const [onSubmit, { loading, error }] = useSaveMinicrud()

  const entity = useModalData()?.entity

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={minicrud || { entity }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditMinicrudForm
